import { GENDER, PREGNANCY_OUTCOME } from './config';
import { normalizeFetuses } from './pregnancyNormalize';

// Quick add (REQ-H1/H2/H3). Desktop's "Add Fetus" does NOT open a form: it confirms, creates the
// record so the symbol appears on the chart straight away, and tells the user to double-click the
// symbol to fill in the detail (which is why REQ-H4's double-click handler is part of the same
// phase). These are the payloads behind that flow — pure, so the field set is pinned by tests
// rather than only exercised through the dialog.

// One fetus, sex unknown (REQ-H3) — the only honest default before a scan.
export const quickFetus = () => ({
  outcome: PREGNANCY_OUTCOME.ongoing,
  fetalSexKnown: false,
  gender: GENDER.unknown,
  hideInPedigree: false
});

// A brand-new pregnancy carrying that one fetus, dated today (REQ-H3). `conceivedWith` and
// `donors` are deliberately LEFT UNSET: a donor is never assumed, so the record asserts nothing
// about conception until a clinician does. `today` is passed in so callers (and tests) control it.
export const quickAddPregnancyPayload = (today) => ({
  fetuses: [quickFetus()],
  // Mirrored onto the legacy top-level fields for the consumers that predate `fetuses` (FHQ
  // tables, PDF, XML serializer, Browse All, record history) — same contract as buildPayload.
  outcome: PREGNANCY_OUTCOME.ongoing,
  fetalSexKnown: false,
  dateOfRecord: today || new Date(),
  hidden: false,
  source: 'pedigree'
});

// One MORE fetus on an existing pregnancy — the pair then renders as twins through the existing
// twin machinery. The whole record is spread so the obstetric fields survive the update, and a
// record written before `fetuses` existed has its implicit singleton materialised first (via the
// same read-side synthesis) so the append cannot silently discard it. `zygosity` is left exactly as
// it was: per Bennett an unrecorded zygosity draws the "?" on the twin apex, which is the correct
// default until a clinician records it.
export const appendFetusPayload = (record) => {
  const fetuses = [...normalizeFetuses(record), quickFetus()];
  return {
    ...record,
    fetuses,
    multiplicity: fetuses.length
  };
};
